export const deepClone = (data: unknown) => structuredClone(data);
